import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader } from '../components/Loader';
import { useAffiliate } from '../api/affiliates/useAffiliate';
import { NotFoundPage } from '../components/NotFoundView/NotFoundPage';

const readAffiliateIdFromUrl = (pathname: string) => {
  const pathSegments = pathname.split('/').filter(Boolean);

  if (pathSegments.length !== 1) throw new Error('Invalid path for affiliate');

  return encodeURIComponent(pathSegments[0]);
};

export const CatchAllRoute = () => {
  const [affiliateId, setAffiliateId] = useState<string | undefined>(undefined);
  const [invalidUrl, setInvalidUrl] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { affiliate, isLoading, isInitialLoading } = useAffiliate({
    affiliateId,
  });

  useEffect(() => {
    try {
      setAffiliateId(undefined);
      setInvalidUrl(false);

      const affiliateId = readAffiliateIdFromUrl(location.pathname);
      
      setAffiliateId(affiliateId);
    } catch (e) {
      setInvalidUrl(true);
    }
  }, [location.pathname, navigate]);

  if (
    invalidUrl ||
    (affiliateId && !affiliate && !isLoading && !isInitialLoading)
  ) {
    return <NotFoundPage />;
  }

  if (!!affiliate) {
    navigate(`/?utm_source=${affiliateId}`, { replace: true });
    return null;
  }

  return <Loader label={'Checking affiliate'} loading={true} />;
};
